import type { SVGProps } from "react";
export interface GiftcardIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GiftcardIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GiftcardIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.203 15.023c0-.095-.029-.18-.148-.287a1.4 1.4 0 0 0-.514-.27l-.262-.065c-.563-.113-1.21-.304-1.736-.688-.584-.424-.996-1.075-.996-1.936q0-.053.004-.105l.002-.005c.047-1.16.853-1.986 1.837-2.344a1.124 1.124 0 0 1 2.217-.013 2.9 2.9 0 0 1 1.716 1.61l.073.193.03.11a1.126 1.126 0 0 1-2.123.71l-.043-.11-.03-.074a.64.64 0 0 0-.187-.218c-.103-.078-.271-.155-.543-.155a.9.9 0 0 0-.573.184c-.113.095-.13.175-.13.214l-.002.003.002.002q.001.044.004.05.001.005.002.005l.003.005.007.01a.4.4 0 0 0 .054.045c.134.097.402.209.854.299 1.238.248 2.732 1.107 2.732 2.83 0 1.231-.782 2.224-1.843 2.64a1.123 1.123 0 0 1-2.219.025 2.9 2.9 0 0 1-1.786-1.802l2.135-.71a.62.62 0 0 0 .217.292c.103.078.271.157.543.157.454 0 .703-.326.703-.602M18 14.376a1.125 1.125 0 1 1 0 2.25h-2a1.126 1.126 0 0 1 0-2.25zm-12.683.088a1.125 1.125 0 0 1 1.423.711l-2.135.71a1.125 1.125 0 0 1 .712-1.421M18 10.374a1.125 1.125 0 1 1 0 2.25h-5a1.125 1.125 0 0 1 0-2.25zm-4.942-8.178a3.387 3.387 0 0 1 4.438-.826l.287.193a3.39 3.39 0 0 1 1.023 4.138l-.163.306-.341.57a1.126 1.126 0 0 1-1.93-1.157l.342-.57.054-.102a1.14 1.14 0 0 0-.343-1.39l-.096-.065a1.137 1.137 0 0 0-1.49.277l-.066.095-1.816 2.927a1.126 1.126 0 0 1-1.914 0L9.227 3.666a1.137 1.137 0 0 0-1.453-.428l-.103.056a1.136 1.136 0 0 0-.383 1.556l.34.571.055.103a1.125 1.125 0 0 1-1.919 1.15L5.7 6.577l-.343-.571A3.387 3.387 0 0 1 6.504 1.37l.303-.164A3.387 3.387 0 0 1 11.14 2.48L12 3.865l.861-1.385.197-.283Z"
      />
      <path
        fill={color}
        d="M20.875 9c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v9c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.875zm2.25 9A4.125 4.125 0 0 1 19 22.125H5A4.125 4.125 0 0 1 .875 18V9A4.125 4.125 0 0 1 5 4.875h14A4.125 4.125 0 0 1 23.125 9z"
      />
    </svg>
  );
}
